import React from 'react';
import Script from 'next/script';

interface WebPageSchemaProps {
  name: string;
  url: string;
  description: string;
}

const GoogleWebPageScript = ({
  name,
  url,
  description,
}: WebPageSchemaProps) => {
  if (!name || !url || !description) {
    return null;
  }

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    url,
    description,
  };

  return (
    <Script
      type="application/ld+json"
      id="webpage-schema"
      key="google-webpage-schema"
    >
      {JSON.stringify(webPageSchema)}
    </Script>
  );
};

export default GoogleWebPageScript;
